interface ToolTipProps {
    ToolTipItem: string;
    top?: string;
    width?: string;
    left?: string;
    bgColor?: string;
    textColor?: string;
}
export default function ToolTip({ToolTipItem, top, width, left, bgColor, textColor} : ToolTipProps) {
  return (
    // Content-sized tooltips are capped and wrapped so a long value cannot stretch
    // into a single line running off the screen. Callers that set an explicit width
    // keep it, since they have already sized the tooltip for their own content.
    <div className={`absolute z-[9999] ${top || '-top-8'} ${left || 'left-0'} ${width || 'w-max'} ${width && width !== 'w-max' ? '' : 'max-w-[320px]'} whitespace-normal break-words hidden group-hover:block ${bgColor || 'bg-black'} ${textColor || 'text-white'} text-xs px-3 py-1 rounded shadow-lg leading-5 pointer-events-none`}>
      <div dangerouslySetInnerHTML={{ __html: ToolTipItem }} />
    </div>
  );
}